<script>
import { Line } from "vue-chartjs";

export default {
    name: "MultiSmoothLineChart",
    extends: Line,
    props: {
        chartData: {
            type: Object,
            required: true,
            default: () => ({ labels: [], datasets: [] }),
        },
        height: {
            type: [String, Number],
            default: 218,
        },
    },
    data() {
        return {
            localOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        padding: 15,
                        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                        fontSize: 12,
                    },
                },
                layout: {
                    padding: { top: 10, bottom: 0, left: 0, right: 0 }
                },
                hover: {
                    mode: "index",
                    intersect: false,
                    animationDuration: 0,
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                            gridLines: {
                                color: '#E5E7EB',
                            },
                        },
                    ],
                },
                elements: {
                    line: {
                        tension: 0.4,
                        borderWidth: 2,
                        fill: false,
                    },
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 5,
                        borderColor: "#FFFFFF",
                        borderWidth: 2,
                    },
                },
                tooltips: {
                    enabled: true,
                    mode: 'index',
                    intersect: false,
                    backgroundColor: '#FCFCFD',
                    titleFontColor: '#384250',
                    bodyFontColor: '#384250',
                    borderColor: '#E5E7EB',
                    borderWidth: 1,
                    cornerRadius: 4,
                    displayColors: true,
                    padding: 8,
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const label = data.datasets[tooltipItem.datasetIndex].label || '';
                            const value = tooltipItem.yLabel;
                            const formattedValue = parseFloat(value).toLocaleString("pt-BR");
                            return `${label}: ${formattedValue}`;
                        },
                    },
                },
            },
        };
    },
    mounted() {
        this.renderLineChart();
    },
    watch: {
        chartData: {
            handler() {
                this.renderLineChart();
            },
            deep: true,
        },
    },
    methods: {
        renderLineChart() {
            this.renderChart(this.chartData, this.localOptions);
        },
    },
};
</script>

